import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import Icon from '@space-lib/components/icon'
import { useTranslation } from 'react-i18next'

export type NotificationCounterProps = {
  totalUnreadNotifications?: number
  onMarkAsRead: () => void
  hideMarkAsReadButton?: boolean
}

const NotificationCounter = ({
  hideMarkAsReadButton = false,
  totalUnreadNotifications = 0,
  onMarkAsRead
}: NotificationCounterProps) => {
  const { t } = useTranslation()
  const minDigits = 2
  const formattedTotalUnreadNotifications =
    totalUnreadNotifications === 0
      ? '0'
      : totalUnreadNotifications.toString().padStart(minDigits, '0')
  const canShowMarkAsReadButton = !hideMarkAsReadButton && totalUnreadNotifications > 0

  const pluralOrSingularSufix = totalUnreadNotifications > 1 ? 'plural' : 'singular'

  return (
    <div className='_p-4 _d-flex _align-items-center _justify-content-between _text-1 _border-top _border-gray-200'>
      <span>
        {t(`notifications.new_counter.${pluralOrSingularSufix}`, {
          value: formattedTotalUnreadNotifications
        })}
      </span>
      {canShowMarkAsReadButton && (
        <button
          className='hot-button hot-button--secondary hot-button--sm  _d-flex _align-items-center'
          onClick={onMarkAsRead}>
          <Icon icon={faCheck} className='_text-gray-900 _text-2 _mr-2' aria-hidden='true' />
          <span>{t('notifications.mark_as_read')}</span>
        </button>
      )}
    </div>
  )
}

export default NotificationCounter
